/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiReport,
    ApiReportFromJSON,
    ApiReportFromJSONTyped,
    ApiReportToJSON,
} from './ApiReport';

/**
 * 
 * @export
 * @interface ApiResultOfMapOfintAndMapOfstringAndApiReport
 */
export interface ApiResultOfMapOfintAndMapOfstringAndApiReport {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: ApiReport; }; }}
     * @memberof ApiResultOfMapOfintAndMapOfstringAndApiReport
     */
    data?: { [key: string]: { [key: string]: ApiReport; }; };
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfintAndMapOfstringAndApiReport
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfintAndMapOfstringAndApiReport
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfintAndMapOfstringAndApiReport
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfintAndMapOfstringAndApiReport
     */
    result?: ApiResultOfMapOfintAndMapOfstringAndApiReportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfintAndMapOfstringAndApiReportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfintAndMapOfstringAndApiReportFromJSON(json: any): ApiResultOfMapOfintAndMapOfstringAndApiReport {
    return ApiResultOfMapOfintAndMapOfstringAndApiReportFromJSONTyped(json, false);
}

export function ApiResultOfMapOfintAndMapOfstringAndApiReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfintAndMapOfstringAndApiReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfintAndMapOfstringAndApiReportToJSON(value?: ApiResultOfMapOfintAndMapOfstringAndApiReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

